import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import {
  EventoPayload,
  EventoResponse,
  EventosResponse,
} from '../../shared/interfaces/evento.interface';
import { skipLoading } from '../interceptors/skip-loading.context';

@Injectable({ providedIn: 'root' })
export class EventosService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  list(desde: string, hasta: string): Observable<EventosResponse> {
    return this.http.get<EventosResponse>(`${this.apiUrl}/eventos`, {
      context: skipLoading(),
      params: { desde, hasta },
    });
  }

  linea(): Observable<EventosResponse> {
    return this.http.get<EventosResponse>(`${this.apiUrl}/eventos/linea`, {
      context: skipLoading(),
    });
  }

  create(payload: EventoPayload): Observable<EventoResponse> {
    return this.http.post<EventoResponse>(`${this.apiUrl}/eventos`, payload, {
      context: skipLoading(),
    });
  }

  update(id: string, payload: EventoPayload): Observable<EventoResponse> {
    return this.http.put<EventoResponse>(`${this.apiUrl}/eventos/${id}`, payload, {
      context: skipLoading(),
    });
  }

  delete(id: string): Observable<{ success: boolean; data: { id: string } }> {
    return this.http.delete<{ success: boolean; data: { id: string } }>(
      `${this.apiUrl}/eventos/${id}`,
      { context: skipLoading() },
    );
  }
}
